import contracts from './modules/contracts/src';
import solutions from './modules/solutions/src';
import subscription from './modules/subscription/src';
import quotes from './modules/quotes/src';

export default [contracts, solutions, subscription, quotes];
